import { ReactNode } from "react";

// Neutralizes the legacy navbar global css shadow rule
export function LegacyStyleWrapper({
  children,
}: {
  children: ReactNode | ReactNode[];
}) {
  return (
    <>
      <style>
        {`
    .navbar {
      box-shadow: none !important;
    }
  `}
      </style>
      {children}
    </>
  );
}
